var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBubbleTriangleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 23,
    viewBox: "0 0 38 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8128 1.33189C17.9979 0.068733 20.0034 0.0687311 21.1885 1.33189L36.777 17.9473C38.5743 19.863 37.216 22.9999 34.5891 22.9999H3.4122C0.785352 22.9999 -0.572971 19.863 1.22435 17.9473L16.8128 1.33189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubbleTriangleWhite);
export default __webpack_public_path__ + "static/media/message-bubble-triangle-white.cf0599fd02a26f19cc94071d1a6ddf8b.svg";
export { ForwardRef as ReactComponent };